import { render } from "./table.vue?vue&type=template&id=20abffb8&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"

import "./table.vue?vue&type=style&index=0&id=20abffb8&lang=css"
import "./table.vue?vue&type=style&index=1&id=20abffb8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20abffb8"]])

export default __exports__